module.exports = __webpack_public_path__ + "img/img_2.cf2587c6.png";